
  .responsive3208187990__root .ColumnController182584914__root .ColumnController182584914__placeholder {
    background-color: #f4f5f8;
  }

  .responsive3208187990__root .ColumnController182584914__root .ColumnController182584914__block.ColumnController182584914--selected {
    background-color: #116dff;
  }

  .responsive3208187990__root .ColumnController182584914__root .ColumnController182584914__inputClass {
    width: 56px !important;
  }

  /* overriding dragHandle styles, because repsonsive theme uses svg with different dimensions */
  .responsive3208187990__root .ColumnController182584914__root .ColumnController182584914__blockWrapper:not(:last-child) {
    margin-right: 14px;
  }

  .responsive3208187990__root .ColumnController182584914__root .ColumnController182584914__dragHandle {
    left: calc(100% - 13px);
    width: 12px;
  }

/* st-namespace-reference="../../../../src/atoms/ColumnController/ColumnController.responsive.st.css" */